import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { getTokenInfo } from "../../utils/Guard";
import "./ABADatatable.css";
import Loading from "../UI/Loading";
import { useSelector } from "react-redux";
import { Steps } from "primereact/steps";

const ABADatatable = (props) => {
  const notification = useSelector((state) => state.ui.notification);

  const [globalFilter, setGlobalFilter] = useState(null);

  const userInfo = getTokenInfo();
  const [isMobile, setIsMobile] = useState(false);
  const [waiting, setWaiting] = useState(true);
  const [seconds, setSeconds] = useState(0);
  const [time] = useState(new Date());

  useEffect(() => {
    if (window.innerWidth <= 430 && !isMobile) {
      setIsMobile(true);
    }
  }, [isMobile]);
  useEffect(() => {
    if (waiting) {
      var tiempo2 = new Date();
      var dif = time.getTime() - tiempo2.getTime();

      var Segundos_de_T1_a_T2 = dif / 1000;
      var Segundos_entre_fechas = Math.abs(Segundos_de_T1_a_T2);

      setSeconds(Segundos_entre_fechas);
      setWaiting(false);
    }
  }, [seconds, time, waiting]);

  useEffect(() => {
    if (
      waiting &&
      props.values !== undefined &&
      props.values.length > 0
    ) {
      setWaiting(false);
    }
    if (notification && notification.status !== "pending") {
      setWaiting(false);
    }
  }, [notification, props, waiting]);

  const header = (
    <div className="formgrid grid">
      <div className="field col-12 md:col-12">
        <i className="pi pi-search "></i>
        <InputText
          icon="pi pi-search"
          type="search"
          className="p-inputtext p-component p-column-filter  search"
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Buscar"
        />
      </div>
      <div className="field col-12 md:col-12">
        {props.backButton !== undefined &&
          props.backButton.permission === "goBack" &&
          isMobile && (
            <Button
              icon="pi pi-arrow-left"
              rounded
              text
              raised
              severity="danger"
              aria-label="Filter"
              onClick={props.backButton.onClick}
              style={{ width: "13%", marginRight: "74%" }}
            />
          )}
        {props.backButton !== undefined &&
          props.backButton.permission === "goBack" &&
          !isMobile && (
            <Button
              rounded
              text
              raised
              className=""
              icon="pi pi-arrow-left"
              severity="danger"
              label={isMobile ? "" : props.backButton.label}
              onClick={props.backButton.onClick}
            />
          )}
        {userInfo.Roles !== undefined &&
          userInfo.Roles.includes(props.createButton.permission) &&
          isMobile && (
            <Button
              icon="pi pi-plus"
              rounded
              text
              raised
              severity="primary"
              aria-label="Filter"
              onClick={props.createButton.onClick}
              style={{ width: "13%" }}
            />
          )}
        {userInfo.Roles !== undefined &&
          userInfo.Roles.includes(props.createButton.permission) &&
          !isMobile && (
            <Button
              rounded
              text
              raised
              className=""
              icon="pi pi-plus"
              severity="primary"
              label={isMobile ? "" : props.createButton.label}
              onClick={props.createButton.onClick}
              style={{ marginLeft: "2%" }}
            />
          )}
      </div>
    </div>
  );

  return (

    <>
    
    <Card
      className="card-content card-style"
      title={props.title}
      style={{
        marginBottom:
          props.marginBottom !== undefined ? props.marginBottom : "10px",
        height: "auto",
        width: "auto",
        padding: "0px",
      }}
    >
      
      <div className="tableContent">
        <DataTable
          stripedRows

          paginator
          className="data-table"
          filterDisplay={props.dontshowMenu === undefined ? "menu" : ""}
          header={header}
          height="100vh"
          globalFilter={globalFilter}
          value={props.values}
          dataKey={props.title}
          rows={props.rows}
          rowsPerPageOptions={props.rowsPerPageOptions}
          sortField={props.sortField}
          sortOrder={-1}
          emptyMessage={
            waiting ? (
              <Loading color="" seconds={seconds} />
            ) : (
              "No se encontraron registros"
            )
          }
        >
          {props.Columns.map((col, i) => (
            <Column
              key={i}
              field={col.field !== undefined ? col.field : ""}
              header={col.header}
              filterMatchMode={col.filterMatchMode}
              body={col.body}
              sortable={col.sortable !== undefined ? col.filter : true}
              filter={col.filter !== undefined ? col.filter : true}
              style={{ width: props.width ? props.width : "35%" }}
            />
          ))}

          {props.actions.length > 0 &&
            props.actions.map((b, i) => {
              return (
                <Column
                  key={i}
                  body={(rowData) => {
                    return <div className="flex">{b(rowData)}</div>;
                  }}
                  style={{ textAlign: "center" }}
                />
              );
            })}
        </DataTable>
      </div>
    </Card>
    </>
  );
};

export default ABADatatable;
